import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { SectionHeading } from "../home/CtaButtons";
import { trackEvent } from "../../lib/api";

export const ADVICE_PAGES = [
  { href: "/kosten-kunststof-kozijnen-zuid-holland", title: "Kosten nieuwe kozijnen", text: "Waar de prijs uit bestaat en hoe u prijzen eerlijk vergelijkt." },
  { href: "/werkwijze", title: "Werkwijze", text: "Van aanvraag en inmeten tot montage en oplevering." },
  { href: "/montage", title: "Montage & afwerking", text: "Hoe een nieuw kozijn stap voor stap wordt geplaatst en afgedicht." },
  { href: "/hr++-glas-isolatieglas", title: "HR++ of HR+++ glas", text: "Isolatie, gewicht, geluid en kosten eerlijk vergeleken." },
  { href: "/isde-subsidie-kozijnen", title: "ISDE-subsidie", text: "Controleer vooraf de voorwaarden voor subsidie op isolatieglas." },
  { href: "/offerte-vergelijken", title: "Offerte vergelijken", text: "Laat uw bestaande offerte vrijblijvend naast uw wensen leggen." },
];

const slug = (href) => href.replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const InfoLinks = ({ current, hrefs }) => {
  const items = hrefs ? ADVICE_PAGES.filter((p) => hrefs.includes(p.href)) : ADVICE_PAGES.filter((p) => p.href !== current).slice(0, 3);
  return (
    <section aria-labelledby="advies-links-title" className="section-tight border-t border-slate-200 bg-slate-50" data-testid="info-links">
      <div className="container-tight">
        <SectionHeading id="advies-links-title" eyebrow="Lees ook" title="Meer kosten & advies" />
        <ul className="mt-8 grid gap-4 md:grid-cols-3">
          {items.map((r) => (
            <li key={r.href}>
              <Link to={r.href} className="card card-hover group flex h-full flex-col p-6" data-testid={`info-link-${slug(r.href)}`}>
                <span className="text-[17px] font-semibold text-ink group-hover:text-maas">{r.title}</span>
                <span className="mt-2 flex-1 text-[14.5px] leading-relaxed text-slate-600">{r.text}</span>
                <span className="mt-4 inline-flex items-center gap-1.5 text-[14px] font-semibold text-maas">Lees meer <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" /></span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export const CheckGrid = ({ items, testid = "check-grid" }) => (
  <ul className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-testid={testid}>
    {items.map((t) => (
      <li key={t} className="flex items-start gap-3 rounded-2xl border border-slate-200 bg-white p-4 text-[15px] text-ink">
        <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-maas-soft"><Check className="h-4 w-4 text-maas" aria-hidden="true" /></span>{t}
      </li>
    ))}
  </ul>
);

export const RouteCards = ({ items, location }) => (
  <ul className="grid gap-5 lg:grid-cols-3" data-testid="route-cards">
    {items.map(({ icon: Icon, ...r }) => (
      <li key={r.href} className={`flex flex-col rounded-2xl p-6 sm:p-7 ${r.primary ? "bg-ink text-white" : "card"}`}>
        <span className={`flex h-11 w-11 items-center justify-center rounded-xl ${r.primary ? "bg-white/10 text-[#7FD3D6]" : "bg-maas-soft text-maas"}`}><Icon className="h-5 w-5" aria-hidden="true" /></span>
        <h3 className={`mt-4 text-[18px] font-semibold ${r.primary ? "text-white" : "text-ink"}`}>{r.title}</h3>
        <p className={`mt-2 flex-1 text-[14.5px] leading-relaxed ${r.primary ? "text-slate-300" : "text-slate-600"}`}>{r.text}</p>
        <Link to={r.href} onClick={() => trackEvent(r.track, { location })} data-testid={`route-card-${slug(r.href.split(/[?#]/)[0])}`}
          className={`mt-5 inline-flex items-center gap-1.5 text-[15px] font-semibold ${r.primary ? "text-white hover:text-[#7FD3D6]" : "text-maas hover:underline"}`}>
          {r.cta} <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </Link>
      </li>
    ))}
  </ul>
);
